import { Grid, Typography, Button } from '@mui/material'
import { Box, Container, keyframes } from '@mui/system'
import React from 'react'



const InternalServerError = () => {
  return (
    <div></div>
  )
}

export default InternalServerError